import React from 'react';
import './section-header.scss';

class SectionHeader extends React.Component{

    constructor(Props){
        super(Props);
        
        this.state = {
            section: Props.title
        }
    }

    setSection(section){
        this.setState({

            section: section,
        });
    }

    render(){
        return (
            <div className="section-header">
                <h2 className="section-title">{this.state.section}</h2>
            </div>
        )
    }
}

export default SectionHeader;